import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import commonMapDispatchToProps from '../../../container/commonMapDispatchToProps';
import commonMapStateToProps from '../../../container/commonMapStateToProps';
import { doRetrieveAllSolutionsMetadata } from '../components/CategoriesRoutes/actions/Solutions';
import Routes from '../components/Routes';

function mapStateToProps(state) {
  return {
    ...commonMapStateToProps(state),
    addonDiscoveryConfig: state.addonDiscovery.config,
    collectionsConfig: state.collections.config,
    solutionsConfig: state.solutions.config,
    solutionsMetadata: state.solutions.solutionsMetadata,
    vendorDetailsConfig: state.vendorDetails.config,
  };
}

const mapDispatchToProps = dispatch => ({
  ...commonMapDispatchToProps(dispatch),
  retrieveAllSolutionsMetadata: ({ commonConfig, solutionsConfig }) =>
    dispatch(doRetrieveAllSolutionsMetadata({ commonConfig, solutionsConfig })),
});

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return {
    ...ownProps,
    ...stateProps,
    ...dispatchProps,
    retrieveAllSolutionsMetadata: () =>
      dispatchProps.retrieveAllSolutionsMetadata({
        commonConfig: stateProps.commonConfig,
        solutionsConfig: stateProps.solutionsConfig,
      }),
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
  )(Routes)
);
